module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/2_b83de7dce3035c189dc7239edb062887.png";